import LayoutWrapper from "@/components/layouts/LayoutWrapper";
import LayoutProvider from "@/providers/LayoutProvider";
import RightsManager from "@/providers/RightsManager";
import SessionProvider from "@/providers/SessionProvider";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { QueryClientProvider } from '@tanstack/react-query';
import queryClient from '@/api/query';
import useRoutes from "@/hooks/use-routes";
import { useSession } from "@/providers/SessionProvider";
import { UserTypes } from '@/configs/AppConfig';
import { MOD_AUTH } from "@/configs/ModulesConfig"


export function App() {
    return (

        <QueryClientProvider client={queryClient}>
            <SessionProvider>
                <AppRoutesAndProviders />
            </SessionProvider>
        </QueryClientProvider>
    );
}

export function AppRoutesAndProviders() {
    const { isAuthenticated, userType } = useSession()
    const routes = useRoutes(userType)
    if (!userType) return
    // console.log(routes)

    const default_path = (() => {
        if (userType == UserTypes.GUEST) return MOD_AUTH.default_log_in_path
        else if (userType == UserTypes.SYSTEM_USER) return MOD_AUTH.system_user_default_path_when_logged_in
        else if (userType == UserTypes.APP_USER) return MOD_AUTH.app_user_default_path_when_logged_in
        return '/'
    })()

    return (
        <BrowserRouter>
            <LayoutProvider>
                <LayoutWrapper>
                    <Routes>
                        {/* 1. Dynamically render the routes from your array */}
                        {routes.map((route, index) => (
                            <Route
                                key={index}
                                path={route.path}
                                element={route.element}
                            />
                        ))}

                        {/* 2. Set the default route (/) to redirect to the Login page */}
                        <Route path="/" element={<Navigate to={default_path} replace />} />

                        {/* 3. Catch-all route to redirect any unknown URLs to Login */}
                        <Route path="*" element={<Navigate to={default_path} replace />} />
                    </Routes>
                    <Toaster />
                    <RightsManager />
                </LayoutWrapper>
            </LayoutProvider>
        </BrowserRouter>
    )

}

export default App;